import React, { useEffect } from "react";
import { usePostOrderData } from "../../hooks";
import { useNavigate } from "react-router-dom";

import {
  HubDialogContent,
  HubHookFormWrapper,
  HubToolbar,
} from "../../components";
import { useDialogContext } from "../HubDialogWrapper";

import PoDetails from "./PoDetails";
import { formOrderMapper } from "./helper";

const CreatePurchaseOrderContent = ({ _flushPurchaseOrder = () => {} }) => {
  const { onClose = () => {}, open: customerId } = useDialogContext();

  const navigate = useNavigate();

  const {
    mutate: postOrderData,
    isLoading,
    isSuccess,
    data,
  } = usePostOrderData();

  const onSubmit = (fd) => {
    const payload = formOrderMapper(fd);
    postOrderData(payload);
  };

  const handleClose = () => {
    onClose();
    _flushPurchaseOrder();
  };

  useEffect(() => {
    if (isSuccess && data?.id) {
      navigate(`/orders/${data?.id}`);
      handleClose();
    }
  }, [isSuccess, data]);

  return (
    <>
      <HubToolbar
        label="Create Purchase Order"
        onClose={handleClose}
        buttonProps={{ icon: "X" }}
        sx={{ padding: "20px !important", margin: 0 }}
      />
      <HubDialogContent largePadding>
        <HubHookFormWrapper
          onSubmit={onSubmit}
          defaultValues={{ customerId }}
          sx={{ height: "100%" }}
        >
          <PoDetails isLoading={isLoading} customerId={customerId} />
        </HubHookFormWrapper>
      </HubDialogContent>
    </>
  );
};
export default CreatePurchaseOrderContent;
